import { forwardRef } from "react";
function SvgRawChevronLeftIcon({ title, titleId, ...props }, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      role="img"
      ref={ref}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth={2}
        d="M21 27 10 16 21 5"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgRawChevronLeftIcon);
export default ForwardRef;
